<template>
<LayoutDefault>
    <InformationPage :page="pageData" />
</LayoutDefault>
</template>
<script setup lang="ts">
const { t } = useI18n()
const api = useApi();
// const config = useRuntimeConfig()
const route = useRoute();
const { locale } = useI18n();

const slugPath = computed(() => (route.params.slug as string[] || []).join('/'))

const {
  data: pageData
} = await useAsyncData(() => safeKey(`page-${slugPath.value}-${locale.value}`), () => api.getPageByPath(slugPath.value), {
  immediate: true,
  server: true,
  lazy: false,
  default: () => null,
  transform: res => res.data,
  watch: [locale]
});

if (!pageData.value) {
  throw createError({ statusCode: 404, statusMessage: t('errors.pageNotFound'), fatal: true });
}

if (import.meta.client && pageData.value?.id) {
  useTrackingPayload().value = { pageId: pageData.value.id, routeKey: route.fullPath }
}

const isInteractivePage = (page: any) => {
  return page?.type && ['interactive_page', 'contact_page'].includes(page?.type)
}

useSeoMeta({
  title: pageData.value?.meta_title,
  description: pageData.value?.meta_description
})

useCmsHreflang(() => pageData.value?.alternate_urls)
</script>